import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import template from './site-operational-status-device-list.html';

const mapStateToThis = ({ siteOperationalStatus }) => {
  const { retailers } = siteOperationalStatus;

  return {
    retailers,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class SiteOperationalStatusDeviceListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.items = [];
    const selectedRetailer = this.retailers
      .find((retailer) => retailer.retailerId === this.retailerId);

    if (selectedRetailer) {
      const { details } = selectedRetailer;
      if (!isEmpty(details)) {
        this.items = cloneDeep(details);
        this.items[0].active = true;
      }
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  showDevice(selectedItem) {
    this.items.map((item) => {
      item.active = false;
      return item;
    });

    selectedItem.active = true;
  }
}

export default class SiteOperationalStatusDeviceListComponent {
  constructor() {
    this.controller = SiteOperationalStatusDeviceListController;
    this.template = template;
    this.bindings = {
      retailerId: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/components/site-operational-status-device-list/site-operational-status-device-list-component.js